import React from 'react';
import clsx from 'clsx';
import { useMoodEngine } from '@/hooks/useMoodEngine';
import type { MoodContext } from '@/types';

/**
 * MoodSelector Component
 * Displays mood selection pills with emojis
 * Horizontally scrollable on mobile
 */
export const MoodSelector: React.FC = () => {
  const { selectedMood, setMood, allMoods } = useMoodEngine();

  const handleMoodClick = (mood: MoodContext) => {
    setMood(mood);
  };

  return (
    <div className="w-full">
      <h2 className="text-lg md:text-xl font-bold mb-3">1. What's your vibe?</h2>

      <div className="overflow-x-auto scrollbar-hidden -mx-4 px-4">
        <div className="flex gap-2 min-w-max py-1">
          {allMoods.map((moodConfig) => (
            <button
              key={moodConfig.mood}
              onClick={() => handleMoodClick(moodConfig.mood)}
              className={clsx(
                'min-h-touch px-4 py-2.5 md:px-5 md:py-2 rounded-full text-sm md:text-base font-medium transition-all whitespace-nowrap',
                {
                  'bg-spotify-green text-black scale-105 shadow-lg shadow-spotify-green/20': selectedMood === moodConfig.mood,
                  'bg-gray-800 text-gray-300 hover:bg-gray-700 active:bg-gray-600': selectedMood !== moodConfig.mood,
                }
              )}
              title={moodConfig.description}
            >
              <span className="mr-1.5">{moodConfig.emoji}</span>
              <span>{moodConfig.label}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MoodSelector;
